<template>
  <product-reviews-summary v-if="product?.rating" :product :reviews-data="reviewsSummaryData" />
</template>

<script lang="ts" setup>
const { product, reviewsSummaryData } = usePdp()
</script>
